export default __webpack_public_path__ + "static/media/pancake.99c9d452.svg";